import { useEffect, useState } from "react";
import * as constent from "util/constent";
import { useAuthContext } from "components/context/authContext";
import "./loading.scss";

export default function Loading() {
  const { viewPort } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [text, setText] = useState("Loading");

  const handleOpen = (e: any) => {
    const { isLoading, text } = e?.detail;
    setIsLoading(isLoading);
    setText(text);
  };

  useEffect(() => {
    window.addEventListener(constent.CONST_COMM_LOAD_CONTROL, handleOpen);

    return () => {
      window.removeEventListener(constent.CONST_COMM_LOAD_CONTROL, handleOpen);
    };
  });
  return (
    <div
      className={isLoading ? "modal-layout bg-dark fetch-loading" : "hidden"}
    >
      <div className={`lds-wrap ${viewPort?.screen === "mb" ? "small" : ""}`}>
        <div className="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
